module.exports = __webpack_public_path__ + "static/media/clock.3637abd7.svg";